import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { datasets } from '../api/client';

export default function UploadPage() {
  const [file, setFile] = useState(null);
  const [instrument, setInstrument] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [warnings, setWarnings] = useState([]);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('Please select a file.');
      return;
    }
    if (!instrument.trim()) {
      setError('Please enter an instrument name.');
      return;
    }

    setError('');
    setWarnings([]);
    setLoading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('instrument', instrument.trim());
    if (name.trim()) {
      formData.append('name', name.trim());
    }

    try {
      const res = await datasets.upload(formData);
      if (res.data.warnings?.length) {
        setWarnings(res.data.warnings);
      }
      navigate('/');
    } catch (err) {
      const data = err.response?.data;
      if (data?.errors) {
        setError(data.errors.join('\n'));
        if (data.warnings?.length) {
          setWarnings(data.warnings);
        }
      } else {
        setError('Upload failed.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <h2>Import Market Data</h2>
      <div className="card">
        {error && <div className="error-msg">{error}</div>}
        {warnings.length > 0 && (
          <div className="warning-msg">
            <strong>Warnings:</strong>
            <ul>
              {warnings.map((w, i) => (
                <li key={i}>{w}</li>
              ))}
            </ul>
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>CSV File (MT5 export or generic OHLC)</label>
            <input
              type="file"
              accept=".csv,.txt"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </div>
          <div className="form-group">
            <label>Instrument</label>
            <input
              type="text"
              placeholder="e.g. EURUSD, NAS100, DAX40"
              value={instrument}
              onChange={(e) => setInstrument(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Dataset Name (optional)</label>
            <input
              type="text"
              placeholder="Leave empty to use filename"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Importing...' : 'Import'}
          </button>
        </form>
      </div>
    </div>
  );
}
